var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ../~/isarray/index.js
// module id = ../node_modules/isarray/index.js
// module chunks = 0